import { render } from "./ConsumerInfoHeader.vue?vue&type=template&id=a16f38c6&scoped=true"
import script from "./ConsumerInfoHeader.vue?vue&type=script&lang=js"
export * from "./ConsumerInfoHeader.vue?vue&type=script&lang=js"

import "./ConsumerInfoHeader.vue?vue&type=style&index=0&id=a16f38c6&scoped=true&lang=css"
import "./ConsumerInfoHeader.vue?vue&type=style&index=1&id=a16f38c6&lang=css"
script.render = render
script.__scopeId = "data-v-a16f38c6"

export default script